import { render, staticRenderFns } from "./FertilizationAmount.vue?vue&type=template&id=d0d8f47a&scoped=true&lang=html&"
import script from "./FertilizationAmount.vue?vue&type=script&lang=js&"
export * from "./FertilizationAmount.vue?vue&type=script&lang=js&"
import style0 from "./FertilizationAmount.vue?vue&type=style&index=0&id=d0d8f47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d8f47a",
  null
  
)

export default component.exports